'use es6';

import { FetchSettingsRequestTypes } from '../actions/SettingsActions';

const Settings = (state = {}, {
  type,
  payload
}) => {
  switch (type) {
    case FetchSettingsRequestTypes.RECEIVE:
      return payload.data.toJS();

    default:
      return state;
  }
};

export default Settings;